import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from '@angular/router';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { fadeAnimation } from '../../animations/fade_list_animations';
import { AngularFireDatabase } from '@angular/fire/database';

declare const google: any;
var polygonSelfIntersect = require('polygon-selfintersect');

interface ConfigRotaMapa {
  IDNomeRota: string;
  NomeRota: string;
  IDRota: string;
}

@Component({
  selector: 'app-mapa-rotas',
  templateUrl: './mapa-rotas.component.html',
  styleUrls: ['./mapa-rotas.component.scss', '../../styles/estilo.padrao.scss'],
  animations: [fadeAnimation]
})
export class MapaRotasComponent implements OnInit {
  uid;

  bConsulta: boolean = false;

  sBuscaIDCidade: string; //ID da cidade de Barbacena
  aTodasCidades: any[] = [];
  aCidades: any[] = [];

  lat: number = -21.2177228;
  lng: number = -43.7670373;
  zoom: number = 14;

  sBuscaUF: string;
  aUFs: any[] = [];

  maxAreas = 30;
  colors = [{ color: '#1E90FF', status: false }, { color: '#FF1493', status: false }, { color: '#32CD32', status: false }, { color: '#FF8C00', status: false }, { color: '#4B0082', status: false },
  { color: '#C0392B', status: false }, { color: '#1A5276', status: false }, { color: '#0E6655', status: false }, { color: '#B7950B', status: false }, { color: '#515A5A', status: false },
  { color: '#836FFF', status: false }, { color: '#00CED1', status: false }, { color: '#98FB98', status: false }, { color: '#F5DEB3', status: false }, { color: '#DDA0DD', status: false },
  { color: '#b4e6ed', status: false }, { color: '#160000', status: false }, { color: '#dbd8d1', status: false }, { color: '#a8c5cd', status: false }, { color: '#edcb8b', status: false },
  { color: '#063970', status: false }, { color: '#abdbe3', status: false }, { color: '#80391e', status: false }, { color: '#44bcd8', status: false }, { color: '#b97455', status: false },
  { color: '#13A30C', status: false }, { color: '#A10CA3', status: false }, { color: '#A30C0C', status: false }, { color: '#B99999', status: false }, { color: '#EAFA1B', status: false }
];
  drawingManager;
  selectedShape;
  polygon;
  allShapes = []; //TODAS AS AREAS, inclusive recuperadas do BD
  // allConfigRota: Anuncio_V2[][] = []; //TODAS as configs do determinado anúncio
  allConfigRota: ConfigRotaMapa[][] = []; //TODAS as configs do determinado anúncio
  paths: any[][] = []; //Pega os dados salvos da area carregada para carregar ao mapa

  infowindowManager;
  allMarkers = []; //TODAS OS MARKERS
  diasSemana = ['Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado', 'Domingo']; //Dias da semana

  sMarkers = 'Ocultar markers'
  map; //Necessário para controle da infowindow

  //Botão de excluir
  classButton = 'disabled';
  bClicavel = false;


  areaSelecionada;
  indexArrayDataAtual = -1;
  arrayDatas = [];

  public CLOSE_ON_SELECTED = false;
  public init = new Date();
  public resetModel = new Date(0);
  @ViewChild(MatDatepicker) _picker: MatDatepicker<Date>;

  //Responsável por colorir a classe da data selecionada;
  public dateClass = (date: Date) => {
    if (this._findDate(date) !== -1) {
      return ['selected'];
    }
    return [];
  }

  public dateChanged(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;

      //Verifica se o array correspondente já existe;
      if (this.indexArrayDataAtual === -1) {
        this.arrayDatas.push(date);
      } else {

        //Caso NÃO exista, ele adiciona no array e na marca do calendário. Caso contrário, remove
        const index = this._findDate(date);

        if (index === -1) {
          let auxDate = this.arrayDatas[this.indexArrayDataAtual] ? this.arrayDatas[this.indexArrayDataAtual] : [];
          auxDate.push(date);
          this.arrayDatas[this.indexArrayDataAtual] = auxDate;
        } else {
          //Remove a seleção no calendário;
          this.arrayDatas[this.indexArrayDataAtual].splice(index, 1);
        }
      }

      this.resetModel = new Date(0);
      if (!this.CLOSE_ON_SELECTED) {
        const closeFn = this._picker.close;
        this._picker.close = () => { };
        this._picker['_popupComponentRef'].instance._calendar.monthView._createWeekCells()
        setTimeout(() => {
          this._picker.close = closeFn;
        });
      }
    }
  }

  //Remove as datas pelo chip list
  public remove(date: Date): void {
    const index = this._findDate(date);
    this.arrayDatas[this.indexArrayDataAtual].splice(index, 1);
  }

  //Encontra a data e retorna o index
  private _findDate(date: Date): number {
    return this.arrayDatas[this.indexArrayDataAtual] ? this.arrayDatas[this.indexArrayDataAtual].map((m) => +m).indexOf(+date) : -1;
  }

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private zone: NgZone,
    private db: AngularFireDatabase,
  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('mapa-rotas');

    //Pegar o ID da cidade para carregar o mapa (evitar o bug do index null)
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDCidade) {
        this.sBuscaUF = dado.UF;
        this.sBuscaIDCidade = dado.IDCidade;
      } else {
        this.sBuscaUF = 'MG';
        this.sBuscaIDCidade = '-Mdc_1tVXl1DsLUwvqU2';
      }
    });
  }

  ngOnInit(): void {
    this.usuarioService.getCidades(this.uid).pipe(take(1)).subscribe(snap => {
      this.aCidades = [];
      let auxIndex;

      if (snap.length > 0) {
        var dados;
        var auxDadosCidade;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          auxIndex = this.aUFs.findIndex(x => x.value === item.key);

          if (auxIndex === -1) {
            this.aUFs.push({
              value: item.key,
              name: item.key,
            });
          }

          Object.keys(dados).forEach((key, index) => {
            auxDadosCidade = dados[key];
            if (auxDadosCidade.Status) {
              this.aTodasCidades.push({
                key: key, //ID da cidade
                uf: item.key,
                value: auxDadosCidade.Cidade,
                name: auxDadosCidade.Cidade,
                latitude: auxDadosCidade.Latitude,
                longitude: auxDadosCidade.Longitude,
              })
            }
          });
        });

        this.aUFs.sort((a, b) => a.name.localeCompare(b.name));
        // this.aTodasCidades.sort((a, b) => a.name.localeCompare(b.name));
        this.carregarCidades(true);
      }
    });
  }

  buscarRotasCidade() {
    this.spinner.show('default');
    this.bConsulta = true;

    const dadosCidade = this.aCidades[this.aCidades.findIndex(x => x.key === this.sBuscaIDCidade)];
    this.lat = dadosCidade.latitude;
    this.lng = dadosCidade.longitude;

    this.usuarioService.getRotas(this.sBuscaIDCidade).pipe(take(1)).subscribe(snap => {
      if (snap) {
        // Carrega as rotas salvas
        const dadosRota: any = snap;
        let auxDadosRota;

        if (dadosRota) {
          Object.keys(dadosRota).forEach((key, index) => {
            auxDadosRota = dadosRota[key];
            let auxConfigRota: ConfigRotaMapa[] = []

            this.paths.push(JSON.parse(auxDadosRota.Area));

            auxConfigRota = [
              { IDNomeRota: this.getIDUnico(), NomeRota: auxDadosRota.Nome, IDRota: key },
            ];

            //É necessário iniciar como DATE os dados para o reconhecimento do matDatepicker
            const auxDatas = JSON.parse(auxDadosRota.Datas);
            let auxArrayDatas = [];
            for (let i = 0; i < auxDatas.length; i++) {
              auxArrayDatas.push(new Date(auxDatas[i]))
            }

            this.arrayDatas.push(auxArrayDatas);
            this.allConfigRota.push(auxConfigRota);
          });
        }
      }

      this.mapListeningLoadPoints(this.map)
      setTimeout(() => this.spinner.hide('default'), 200);
    });

  }

  onMapReady(map) {
    map.setOptions({
      streetViewControl: false
    });
    this.initDrawingManager(map);
  }

  initDrawingManager(map: any) {
    this.map = map;

    //Opções de controle
    const options: any = {
      drawingControl: true,
      drawingControlOptions: {
        drawingModes: ["polygon"]
      },
      polygonOptions: {
        draggable: true,
        editable: true,
        clickable: true,
      },
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      // drawingMode: google.maps.POLYGON,
    };

    this.drawingManager = new google.maps.drawing.DrawingManager(options);
    this.drawingManager.setMap(map);


    var marker;
    this.infowindowManager = new google.maps.InfoWindow();

    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', e => {

      //Coloca "parar de desenhar" como padrão.
      if (this.drawingManager.getDrawingMode()) {
        this.drawingManager.setDrawingMode(null);
      }


      var newShape = e.overlay;

      if (!polygonSelfIntersect.findSelfIntersections(this.getShapeCoordsClear(newShape))) {
        let color = this.tratarCor(true, null);
        newShape.setOptions({
          clickable: true,
          fillColor: color,
          strokeColor: color,
        });
        let id = this.getIDUnico();
        newShape.id = id

        newShape.type = e.type;

        let aux: any = new Array();

        for (let y = 0; y < this.diasSemana.length; y++) {

          aux.push({
            DiaSemana: this.diasSemana[y], //Pegar o dia da semana
            Status: false,
            IDNomeRota: this.getIDUnico(),
            NomeRota: '' //Vazio porque foi adicionado neste momento, para salvar pega pelo ID;
          });
        }

        this.allConfigRota.push(aux);

        //Cria o Marker
        let contentString =
          '<div style="width: 250px">' +

          '<div style="position: relative;">' +
          '<div style="font-weight: bold; text-align: center; font-size: 16px; padding-left: 20px;" type="text" />Área ' + (this.allShapes.length + 1) +
          '<div style="background-color: ' + color + '; width: 10px; height: 10px; display: inline-block; margin-left: 7px"></div></div></p>' +
          '<input id="' + this.allConfigRota[this.allConfigRota.length - 1][0].IDNomeRota + '_input' + '"style="width: 240px; margin-left:5px; height: 25px; border: 1px solid blue; border-radius: 4px; padding-top: 3px; margin-top: 4px; text-align: center; font-size: 15px; display: inline-block;" placeholder="Nome da rota" type="text" maxlength="150" value="">' +
          '</div>' +
          '</div>';

        let infoWindow = new google.maps.InfoWindow({
          content: contentString,
          id: id
        });

        marker = new google.maps.Marker({
          position: this.getCenterPolygon(this.getShapeCoords(newShape)),
          map: map,
          title: 'Área ' + (this.allConfigRota.length + 1),
          //icon: '/assets/icons/pin_2.svg',
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
          },
          draggable: true,
        });
        infoWindow.open(map, marker);
        this.allMarkers.push(infoWindow);

        //Adiciona evento a cada newShape
        google.maps.event.addListener(newShape, 'click', resp => {
          this.setSelection(newShape);

          //É invocado sempre que um novo ponto é adicionado ao polígono.
          // google.maps.event.addListener(newShape.getPath(), 'insert_at', resp => {
          //   console.log("allshapes index updated =", this.allShapes.indexOf(newShape));
          // });
          //É chamado sempre que um ponto no polígono é removido.
          // google.maps.event.addListener(newShape.getPath(), 'remove_at', resp => {
          //   //Já temos uma função externa para exclusão do polígono
          // });

        });

        //É chamado sempre que um ponto no polígono é editado.
        google.maps.event.addListener(newShape.getPath(), 'set_at', resp => {
          this.allMarkers[this.allShapes.indexOf(newShape)].setPosition(this.getCenterPolygon(this.getShapeCoords(newShape)));
        });


        this.allShapes.push(newShape);

        //after drawing = set selected
        this.setSelection(newShape);

        setTimeout(() => this.arrayDatas[this.indexArrayDataAtual] = [], 300);

        //Se o total de formas for === o total de áreas, é bloqueado a opção de criar um novo polígono
        if (this.allShapes.length === this.maxAreas) {
          this.drawingManager.setOptions({
            drawingControl: false
          });
        }

        //Controla o botão de exclusão
        this.allShapes.length >= 1 ? (this.bClicavel = true, this.classButton = 'warn') : (this.bClicavel = false, this.classButton = 'disabled');
      } else {
        this.setSelection(newShape);
        this.deleteSelectedShape(false);
        alert('Não é possível adicionar um polígono com intercessão!');
      }
    });

    //google.maps.event.addListener(this.drawingManager, 'click', this.clearSelection());
  }

  mapListeningLoadPoints(map) {
    let color
    //Loop para load dos polígonos já armazenados
    for (let i = 0; i < this.paths.length; i++) {
      color = this.tratarCor(true, null);

      let auxLoadShape = new google.maps.Polygon({
        paths: this.paths[i],
        fillColor: color,
        strokeColor: color,
        draggable: true,
        editable: true,
        clickable: true,
      });
      let id = this.getIDUnico();
      auxLoadShape.id = id

      this.allShapes.push(auxLoadShape);

      let contentString =
        '<div style="width: 250px">' +

        '<div style="position: relative;">' +
        '<div style="font-weight: bold; text-align: center; font-size: 16px; padding-left: 20px;" type="text" />Área ' + (i + 1) +
        '<div style="background-color: ' + color + '; width: 10px; height: 10px; display: inline-block; margin-left: 7px"></div></div></p>' +
        '<input id="' + this.allConfigRota[i][0].IDNomeRota + '_input' + '"style="width: 240px; margin-left:5px; height: 25px; border: 1px solid blue; border-radius: 4px; padding-top: 4px; margin-top: 4px; text-align: center; font-size: 15px; display: inline-block;" placeholder="Nome da rota" type="text" maxlength="150" value="' + this.allConfigRota[i][0].NomeRota + '">' +
        '</div>' +
        '</div>';

      let infoWindow = new google.maps.InfoWindow({
        content: contentString,
        id: this.allConfigRota[i][0].IDNomeRota
      });

      let marker = new google.maps.Marker({
        position: this.getCenterPolygon(this.getShapeCoords(auxLoadShape)),
        map: map,
        title: 'Área ' + (i + 1),
        //icon: '/assets/icons/pin_2.svg',
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0
        },
        draggable: true,
      });
      infoWindow.open(map, marker);
      this.allMarkers.push(infoWindow);

      //É invocado sempre que um novo ponto é adicionado ao polígono.
      google.maps.event.addListener(auxLoadShape.getPath(), 'insert_at', resp => {
        // this.allMarkers[this.allShapes.indexOf(auxLoadShape)].setIcon({icon: {path: google.maps.SymbolPath.CIRCLE,scale: 0}});
        //this.allMarkers[this.allShapes.indexOf(auxLoadShape)].setPosition(this.getCenterPolygon(this.getShapeCoords(auxLoadShape)));

        this.allMarkers[this.allShapes.indexOf(auxLoadShape)].setPosition(this.getCenterPolygon(this.getShapeCoords(auxLoadShape)));
      });

      //É chamado sempre que um ponto no polígono é editado.
      google.maps.event.addListener(auxLoadShape.getPath(), 'set_at', resp => {
        //infowindow.open(map, marker);
        this.allMarkers[this.allShapes.indexOf(auxLoadShape)].setPosition(this.getCenterPolygon(this.getShapeCoords(auxLoadShape)));
      });

      //É chamado sempre que um ponto no polígono é removido.
      google.maps.event.addListener(auxLoadShape.getPath(), 'remove_at', resp => {
        //Já temos uma função externa para exclusão do polígono

        this.allMarkers[this.allShapes.indexOf(auxLoadShape)].close();
        this.allMarkers.splice(this.allShapes.indexOf(auxLoadShape), 1);
      });

      //Adiciona evento ao clicar e executar os demais //Pode ficar separado
      google.maps.event.addListener(auxLoadShape, 'click', resp => {
        this.setSelection(auxLoadShape); //Necessário para controle externo
      });
      auxLoadShape.setMap(map);

      //Para remover a seleção externa, é preciso primeiramente setar
      this.setSelection(auxLoadShape);
      this.clearSelection();

      //Coloca "parar de desenhar" como padrão.
      if (this.drawingManager.getDrawingMode()) {
        this.drawingManager.setDrawingMode(null);
      }

      //Se o total de formas for === o total de áreas, é bloqueado a opção de criar um novo polígono
      if (this.allShapes.length === this.maxAreas) {
        this.drawingManager.setOptions({
          drawingControl: false
        });
      }
    }
  }

  clearSelection() {
    if (this.selectedShape) {
      this.indexArrayDataAtual = -1;
      this.selectedShape.setEditable(false);
      this.selectedShape = null;

      //Bloqueia o botão delete
      this.bClicavel = false;
      this.classButton = 'disabled';
    }
  }

  //set selection to a shape
  setSelection(shape) {
    this.clearSelection();
    this.selectedShape = shape;
    shape.setEditable(true);

    this.indexArrayDataAtual = this.allShapes.indexOf(this.selectedShape);
    this.areaSelecionada = 'Área ' + (this.indexArrayDataAtual + 1);

    //Libera delete
    this.bClicavel = true;
    this.classButton = 'warn';

    this.zone.run(() => null);
  }

  deleteSelectedShape(b) {
    if (this.bClicavel) {
      if (!this.selectedShape) {
        alert("Não há nenhuma área selecionada!");
        return;
      } else {

        if (b) {
          var index = this.allShapes.indexOf(this.selectedShape);
          this.allShapes.splice(index, 1);

          this.allMarkers[index].close()
          this.allMarkers.splice(index, 1)

          this.allConfigRota.splice(index, 1)

          this.tratarCor(false, this.selectedShape.fillColor);

          //Remove por completo a linha da área selecionada
          this.arrayDatas.splice(this.indexArrayDataAtual, 1);

          this.selectedShape.setMap(null);
          this.drawingManager.setOptions({
            drawingControl: true
          });
        }
        this.selectedShape.setMap(null);
        this.drawingManager.setOptions({
          drawingControl: true
        });
      }
      this.clearSelection();
    }
  }

  alterarMarkers() {
    if (this.sMarkers === 'Ocultar markers') {
      for (let i = 0; i < this.allMarkers.length; i++) {
        this.allMarkers[i].close();
      }
      this.sMarkers = 'Exibir markers';
    } else {
      for (let i = 0; i < this.allMarkers.length; i++) {
        this.allMarkers[i].open(this.map);
      }
      this.sMarkers = 'Ocultar markers';
    }
  }

  getIDUnico() {
    return '_' + Math.random().toString(36).substr(2, 9);
  };

  calcularWidth() {
    switch (this.diasSemana.length) {
      case 1:
        return '120px !important;';
      case 2:
        return '240px !important;';
      case 3:
        return '360px !important;';
      default: return '400px !important;';
    }
  }

  salvar() {

    if (this.allShapes.length > 0) {
      // this.spinner.show('default');

      //Necessário os markers estarem visíveis para não haver erro de getElementById
      if (this.sMarkers !== 'Ocultar markers') {
        this.sMarkers === 'Ocultar markers';
        this.alterarMarkers();
      }

      let auxMap = new Map();

      let key;
      for (let i = 0; i < this.allShapes.length; i++) {
        key = this.allConfigRota[i][0].IDRota ? this.allConfigRota[i][0].IDRota : this.db.createPushId();

        auxMap[key] = {
          Datas: this.ordernarDatas(JSON.stringify(this.arrayDatas[i])),
          Area: JSON.stringify(this.getShapeCoords(this.allShapes[i])),
          Nome: (<HTMLInputElement>document.getElementById(this.allConfigRota[i][0].IDNomeRota + '_input')).value
        };
      }

      this.usuarioService.setRotas(auxMap, this.sBuscaIDCidade).then(resp => {
        setTimeout(() => this.spinner.hide('default'), 200);

        this.reload();
        this.toastr.clear();
      });
    } else {
      alert('Você não informou nenhuma área de rota!');
    }
  }

  ordernarDatas(datas) {
    let aux = JSON.parse(datas).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    return JSON.stringify(aux);
  }

  reload() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/mapa-rotas"], { queryParams: { UF: this.sBuscaUF, IDCidade: this.sBuscaIDCidade } }));

  }

  carregarCidades(b) {
    this.aCidades = [];
    for (let i = 0; i < this.aTodasCidades.length; i++) {
      if (this.aTodasCidades[i].uf === this.sBuscaUF) {
        this.aCidades.push({
          key: this.aTodasCidades[i].key,
          uf: this.aTodasCidades[i].uf,
          value: this.aTodasCidades[i].value,
          name: this.aTodasCidades[i].name,
          latitude: this.aTodasCidades[i].latitude,
          longitude: this.aTodasCidades[i].longitude,
        });
      }
    }

    this.aCidades.sort((a, b) => a.name.localeCompare(b.name));
    b ? this.buscarRotasCidade() : null;
    setTimeout(() => this.spinner.hide('mapa-rotas'), 300);
  }

  getCenterPolygon(pts) {
    var first = pts[0], last = pts[pts.length - 1];
    if (first.lat != last.lat || first.lng != last.lng) pts.push(first);
    var twicearea = 0,
      lat = 0, lng = 0,
      nPts = pts.length,
      p1, p2, f;
    for (var i = 0, j = nPts - 1; i < nPts; j = i++) {
      p1 = pts[i]; p2 = pts[j];
      f = p1.lat * p2.lng - p2.lat * p1.lng;
      twicearea += f;
      lat += (p1.lat + p2.lat) * f;
      lng += (p1.lng + p2.lng) * f;
    }
    f = twicearea * 3;
    return { lat: lat / f, lng: lng / f };
  }

  //get path coords
  getShapeCoords(shape) {
    var path = shape.getPath();
    var coords = [];
    for (var i = 0; i < path.length; i++) {
      coords.push({
        lat: path.getAt(i).lat(),
        lng: path.getAt(i).lng()
      });
    }
    return coords;
  }

  //get path coords
  getShapeCoordsClear(shape) {
    var path = shape.getPath();
    var coords = [];
    for (var i = 0; i < path.length; i++) {
      coords.push([
        path.getAt(i).lat(),
        path.getAt(i).lng()
      ]);
    }
    return coords;
  }

  tratarCor(b, color) {
    if (b) {
      for (let i = 0; i < this.colors.length; i++) {
        if (!this.colors[i].status) {
          this.colors[i].status = true;
          return this.colors[i].color;
        }
      }
    } else {
      for (let i = 0; i < this.colors.length; i++) {
        if (this.colors[i].color === color) {
          this.colors[i].status = false;
          return false;
        }
      }
    }

    return false;
  }
}
